// import Vue from "vue";
import Vue from "vue";

const lectio = {
  namespaced: true,
  state: {
    default: {
      uid: "",
      anio: 2020,
      mes: 1,
      dia: 1,
      lng: "",
      ver: "",
      lbPrimera: "",
      txtPrimera: "",
      lbSalmo: "",
      rtaSalmo: "",
      txtSalmo: "",
      lbSegunda: "",
      txtSegunda: "",
      lbEvang: "",
      txtEvang: "",
      fraseReflex: "",
      txtReflex: "",
      oraDia: "",
      oraNoche: ""
    },
    items: {}
  },
  getters: {
    fromSearch: (state, getters, rootState, rootGetters) => search => {
      // search {uid: "2020-01-01", lng: "es", ver: "co"} opcionales: lng ver
      if (search.uid === undefined) return "";

      let userConfig = rootGetters["user/config"];

      let lng = search.lng || userConfig.mdd.lng;
      let ver = search.ver || userConfig.mdd.ver;

      let uid1 = lng + ver + search.uid;
      let uid2 = lng + search.uid;

      let ref1 = state.items[uid1] || false;
      let ref2 = state.items[uid2] || false;

      return ref1 || ref2 || state.default;
    },
    items(state) {
      return state.items;
    }
  },
  mutations: {
    loadItemsFromLocal(state, docs) {
      // {id: es20200520, data: {}}
      docs.forEach(doc => {
        Vue.set(state.items, doc.id, doc.data);
      });
    },
    loadItemsFromWeb(state, docs) {
      docs.forEach(doc => {
        Vue.set(state.items, doc.id, doc.data());
        this.$local.set("lectio/" + doc.id, doc.data());
      });
    }
  },
  actions: {
    load({ commit, getters, rootGetters }, params) {
      // params: {lng: "es", ver: "co", dia: "2020-01-01"}
      let appReady = rootGetters["app/resources"] === 100;
      let userReady = rootGetters["user/ready"] !== null;
      if (!appReady || !userReady) {
        commit(
          "app/loadBefore",
          { dispatch: "lectio/load", payload: params },
          { root: true }
        );
        return "";
      }

      let userConfig = rootGetters["user/config"];
      // params espera, lng, ver, anio, mes, dia
      let lng = params.lng || userConfig.mdd.lng;
      let ver = params.ver || userConfig.mdd.ver;

      // generar uid
      let mes = params.mes < 10 ? "0" + params.mes : params.mes;
      let dia = params.dia < 10 ? "0" + params.dia : params.dia;
      let uid = params.anio + "-" + mes + "-" + dia;

      // codigos de version
      let uid1 = lng + ver + uid;
      let uid2 = lng + uid;

      // array para buscar el contenido
      let items = getters["items"];

      // validar si existe el contenido buscado
      let existe1 = items[uid1] || false;
      let existe2 = items[uid2] || false;

      if (existe1 || existe2) return "";

      // buscamos local
      let doc = this.$local.get("lectio/" + uid1);
      if (doc) {
        commit("loadItemsFromLocal", [{ id: uid1, data: doc }]);
        return;
      }

      doc = this.$local.get("lectio/" + uid2);
      if (doc) {
        commit("loadItemsFromLocal", [{ id: uid2, data: doc }]);
        return;
      }

      // buscamos en firebase
      var lectio = this.$collection.lectio;
      let doc1 = lectio.doc(uid1);
      let doc2 = lectio.doc(uid2);

      doc1
        .get() // uid1 en cache
        .then(doc => {
          return doc.exists
            ? Promise.resolve(doc)
            : Promise.reject("Doc " + uid1 + "no está en caché");
        }) // uid2 en fb
        .catch(() => {
          return doc2.get().then(doc => {
            return doc.exists
              ? Promise.resolve(doc)
              : Promise.reject("Doc " + uid2 + "no está en fb");
          });
        })
        // commit doc
        .then(doc => {
          commit("loadItemsFromWeb", [doc]);
        });
    },
    loadMonth({ commit, getters, rootGetters }, params) {
      // params: {lng: "es", ver: "co", dia: "2020-01-01"}
      let appReady = rootGetters["app/resources"] === 100;
      let userReady = rootGetters["user/ready"] === 100;
      if (!appReady || userReady) {
        commit(
          "app/loadBefore",
          { dispatch: "lectio/loadMonth", payload: params },
          { root: true }
        );
        return "";
      }

      let userConfig = rootGetters["user/config"];
      // params espera, lng, ver, anio, mes, dia
      let lng = params.lng || userConfig.mdd.lng;
      let ver = params.ver || userConfig.mdd.ver;

      // generar uid
      let mes = params.mes < 10 ? "0" + params.mes : params.mes;
      let dia = params.dia < 10 ? "0" + params.dia : params.dia;
      let uid = params.anio + "-" + mes + "-" + dia;

      // codigos de version
      let uid1 = lng + ver + uid;
      let uid2 = lng + uid;

      // array para buscar el contenido
      let items = getters["items"];

      // validar si existe el contenido buscado
      let existe1 = items[uid1] || false;
      let existe2 = items[uid2] || false;

      if (existe1 || existe2) return "";

      // buscamos local
      let doc = this.$local.get(uid1);
      if (doc) {
        commit("loadItemsFromLocal", { id: uid1, data: doc });
        return;
      }

      doc = this.$local.get(uid2);
      if (doc) {
        commit("loadItemsFromLocal", { id: uid2, data: doc });
        return;
      }

      // buscamos en firebase
      var lectio = this.$collection.lectio;
      let doc1 = lectio.doc(uid1);
      let doc2 = lectio.doc(uid2);

      doc1
        .get() // uid1 en cache
        .then(doc => {
          return doc.exists
            ? Promise.resolve(doc)
            : Promise.reject("Doc " + uid1 + "no está en caché");
        }) // uid2 en fb
        .catch(() => {
          return doc2.get().then(doc => {
            return doc.exists
              ? Promise.resolve(doc)
              : Promise.reject("Doc " + uid2 + "no está en fb");
          });
        })
        // commit doc
        .then(doc => {
          commit("loadItemsFromWeb", [doc]);
        });
    }
  }
};

export default lectio;
